import { RouteType } from "@/types/route.type";

export const type = {
  PUBLIC: "public",
  PROTECTED: "protected",
  GUEST: "guest",
};

const routes: RouteType = {
  login: { type: type.GUEST, url: "/login" },
  home: { type: type.PUBLIC, url: "/" },
  cart: { type: type.PUBLIC, url: "/cart" },
  checkout: { type: type.PUBLIC, url: "/checkout" },
  privacy: { type: type.PUBLIC, url: "/privacy-policy" },
  terms: { type: type.PUBLIC, url: "/terms-conditions" },
  refunds: { type: type.PUBLIC, url: "/refund-policy" },
  delivery: { type: type.PUBLIC, url: "/delivery-and-shipping-policy" },
  return: { type: type.PUBLIC, url: "/return-and-exchange-policy" },
  category: { type: type.PUBLIC, url: "/category/:slug" },
  product: { type: type.PUBLIC, url: "/product/:slug" },
  blogs: { type: type.PUBLIC, url: "/blogs" },
  blog: { type: type.PUBLIC, url: "/blogs/:slug" },
  contact: { type: type.PUBLIC, url: "/contact-us" },
  download: { type: type.PUBLIC, url: "/downloads" },
  droneRepair: { type: type.PUBLIC, url: "/drone-repair" },
  droneShow: { type: type.PUBLIC, url: "/drone-show" },
  dronePilotTraining: { type: type.PUBLIC, url: "/drone-pilot-training" },
  gallery: { type: type.PUBLIC, url: "/galleries/:slug" },
  post: { type: type.PUBLIC, url: "/posts/:slug" },
  search: { type: type.PUBLIC, url: "/search" },
  services: { type: type.PUBLIC, url: "/services" },
  shop: { type: type.PUBLIC, url: "/shop" },
  dynamicPage: { type: type.PUBLIC, url: "/:slug" },
  userDashboard: { type: type.PROTECTED, url: "/user/dashboard" },
  userOrders: { type: type.PROTECTED, url: "/user/orders" },
  userOrder: { type: type.PROTECTED, url: "/user/orders/:id" },
  userProfile: { type: type.PROTECTED, url: "/user/profile" },
  userAddresses: { type: type.PROTECTED, url: "/user/addresses" },
};

export default routes;
